import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

import ExternalLink from '../external-link';

import type { Content } from '../../../../types';

const TileWrapper = styled.div`
  border: 1px solid ${COLORS.lightBlue};
  border-radius: 3px;
  width: 325px;
  min-height: 225px;
  padding: 30px;
  margin: 30px !important;

  h1 {
    color: ${COLORS.grayBlack};
    line-height: 29px;
    font-size: 23px;
    padding-bottom: 20px;
  }

  p {
    color: ${COLORS.grayBlack};
    line-height: 24px;
    padding-bottom: 25px;
  }

  @media (min-width: 1041px) {
    min-width: 305px;
  }
  @media (max-width: 1260px) {
    min-width: 330px;
  }
  @media (max-width: 1040px) {
    min-width: 355px;
  }
  @media (max-width: 765px) {
    min-width: 405px;
  }
  @media (max-width: 599px) {
    min-width: 0px;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position:absolute;
  bottom: 20px;
  left:0;

  a.button {
    height: 30px;
    line-height: 20px;
  }
`;

const ResourceTile = ({ title, textContent, buttonText, link }: Content) => (
  <TileWrapper>
    <h1>{title}</h1>
    <p>{textContent}</p>
    <ButtonWrapper>
      <ExternalLink className='button secondary' href={link}>
        {buttonText}
      </ExternalLink>
    </ButtonWrapper>
  </TileWrapper>
);

export default ResourceTile;
